// extracted by mini-css-extract-plugin
export var content = "_bt-3";
export var list = "_bt-4";
export var settingsContent = "_bt-7";
export var settingsPanel = "_bt-8";
export var state = "_bt-6";
export var triggerBadge = "_bt-2";
export var triggerButton = "_bt-1";
export var triggerShell = "_bt-0";
export var unreadDot = "_bt-5";